<template>
  <div class="mfaq-common-header" ref="refMafqCommonHeader">
    <header class="header">
      <heador :title="title">
        <a-button @click="contactVisible = true" v-if="showContact">{{
          $t("index.commonHeader.contactUs")
        }}</a-button>
        <a-button
          type="primary"
          v-show="webchat.isShowH5 && AIHelpSDK"
          @click="openH5Entrance()"
        >
          {{ $t("index.commonHeader.contactUs") }}
        </a-button>
        <a-button
          type="primary"
          v-show="webchat.isShowH5 && isShowFormQuestionnaire"
          @click="openFormQuestionnaireDialog()"
        >
          {{ $t("index.commonHeader.contactUs") }}
        </a-button>
        <a-button
          @click="toggleMenu"
          class="menu-button"
          style="margin-left: 20px"
          >{{ $t("index.commonHeader.menu") }}</a-button
        >
      </heador>
    </header>
    <!-- 过滤器 -->
    <ai-filter
      v-show="showMenu"
      class="menu"
      :app-list="appList"
      :platform-list="platformList"
      :language-list="languageList"
      :app-name="title"
      @change-app="handleAppChange"
      @change-param="handleParamChange"
      @change="handleFilterChange"
      :gameName="gameIdKey"
      :language="language"
      :platform="platform"
      :config="filterConfig"
    ></ai-filter>
    <div class="mask" v-show="showMenu" @click="showMenu = false"></div>
    <!-- {{$t('index.commonHeader.contactUs')}} -->
    <contact-us
      :visible.sync="contactVisible"
      :app-name="appName"
      :game-id="gameId"
    ></contact-us>
    <a-spin
      tip="Loading..."
      v-show="loadingTip"
      style="
        width: 375px;
        height: 500px;
        position: fixed;
        right: 1rem;
        bottom: 4rem;
        z-index: 999;
      "
    >
      <div class="spin-content"></div>
    </a-spin>
    <FormQuestionnaireDialog
      v-if="formDialogVisible"
      :visible.sync="formDialogVisible"
      :game-id="gameId"
    ></FormQuestionnaireDialog>
  </div>
</template>
<script>
import { dealShowPath } from "@/utils/path";
import { throttle } from "@/utils/tool";
import aiFilter from "./component/filters.vue";
//import store from '@/vuex/index'
import { mapState } from "vuex";

export default {
  name: "commonHeader",
  components: {
    heador: () => import("@/components/Heador"),
    aiSelect: () => import("@/components/aiSelect"),
    aiFilter,
    contactUs: () => import("./component/contactUs"),
    FormQuestionnaireDialog: () =>
      import("./component/FormQuestionnaireDialog"),
  },
  props: {
    languageList: {
      type: Array,
      default: () => [],
    },
    language: {
      type: [Number, String],
      default: "",
    },
    appList: {
      type: Array,
      default: () => [],
    },
    platformList: {
      type: Array,
      default: () => [],
    },
    contactUsGameList: {
      type: Array,
      default: () => [],
    },
    gameIdKey: [String, Number],
    platform: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    appName: {
      type: String,
      default: "",
    },
    gameId: {
      type: Number,
    },
  },
  data() {
    return {
      loadingTip: false,
      contactVisible: false,
      showMenu: false,
      AIHelpSDK: false,
      formDialogVisible: false,
    };
  },
  watch: {
    "$store.state.webchat.accountId": {
      handler() {
        if (!this.isShowFormQuestionnaire) {
          this.loadAIHelpSDK(document, "aihelp-chat");
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(["webchat"]),
    showContact() {
      let show1 = this.contactUsGameList.indexOf(this.gameIdKey) > -1;
      let show2 = this.contactUsGameList.indexOf("F3F59C63499B3CC5") > -1;
      return show1 || show2;
    },
    isShowFormQuestionnaire() {
      // 13913 ican 艾肯遊戲客服
      return [13023, 11909, 13913].includes(this.gameId);
    },
    filterConfig() {
      // 57D6C6F0A8026F66 --- 2664
      // 8C9CC8A3F868FA3E --- 13023 MyGamez 国内站 "帝国与谜题"
      // 006495ABCAEF027E --- 11909 上海栖亘 国际站 "HAZEREVERB"
      const isShowLanguageSelect = ![
        "57D6C6F0A8026F66",
        "8C9CC8A3F868FA3E",
        "006495ABCAEF027E",
      ].includes(this.$route.params.gameIdKey);
      return {
        isShowLanguageSelect,
      };
    },
    isShowWebchatV4() {
      // 4623 大海怪 NonstopGame
      return [4623, 10229, 2664].includes(this.gameId);
    },
  },
  mounted() {
    // this.localTitle = this.$route.params.gameName
    this.resietMarginTop();
    const resizeFunc = throttle(this.resietMarginTop, 200);
    window.addEventListener("resize", resizeFunc);
  },
  methods: {
    openFormQuestionnaireDialog() {
      this.formDialogVisible = true;
    },
    loadAIHelpSDK(t, e) {
      if ("function" != typeof window.AIHelpSupport) {
        var n = function () {
          n.q.push(arguments);
        };
        (n.q = []), (window.AIHelpSupport = n);
        var i,
          a = t.getElementsByTagName("script")[0];
        if (t.getElementById(e)) return;
        (i = t.createElement("script")),
          (i.async = !0),
          (i.id = e),
          (i.src = `${window.location.origin}/${
            this.isShowWebchatV4 ? "webchatv4" : "webchat"
          }/aihelp.js`);
        window.attachEvent
          ? i.attachEvent("onload", this.updateAIHelpSDK(true))
          : i.addEventListener("load", this.updateAIHelpSDK(true), !1),
          a.parentNode.insertBefore(i, a);
      } else {
        this.updateAIHelpSDK(true);
      }
    },
    updateAIHelpSDK(flag) {
      this.AIHelpSDK = flag;
    },
    //初始化H5
    initH5() {
      /*
       *	lyh 此处功能为: 某些公司需要显示h5按钮 调用h5仅需要以下几个必填参数
       *  初始化参数 参数在vuex/index.js 中
       *  language: "zh_cn",
       *  isShowH5: 0, // 根据变量是否显示打开H5入口 ture / false
       *  appId: "",
       *  appName:"",
       *  custom: '3'
       */
      this.webchat.domain = window.location.host;
      // this.webchat.domain = "local.aihelp.net";
      this.webchat.appKey = "appKey";
      this.webchat.language = this.language;
      //调用elvah5.init()传入初始化参数
      if (typeof AIHelpSupport !== undefined) {
        AIHelpSupport.init(this.webchat);
      }
    },
    initWebChatV4() {
      const initConfig = {
        appKey: "appKey",
        domain: window.location.host,
        appId: this.webchat.appId,
        entranceId: "E001",
        language: this.language,
      };
      if (AIHelpSupport) {
        AIHelpSupport.init(initConfig);
        AIHelpSupport.show();
      }
    },
    // 调用elvah5.show()弹出elva盒子
    openH5Entrance() {
      if (this.isShowWebchatV4) {
        this.initWebChatV4();
        return;
      }
      this.initH5();
      AIHelpSupport.show();
    },
    handleFilterChange(val) {
      this.$emit("change", val);
    },
    handleAppChange(app) {
      this.$emit("change-app", app);
    },
    handleParamChange(param) {
      this.$emit("change-param", param);
      this.showMenu = false;
    },
    // 计算header高度，用户更新主体的margin-top
    resietMarginTop() {
      let ref = this.$refs.refMafqCommonHeader;
      let height = ref.offsetHeight;
      // let height = window.getComputedStyle(ref).height
      this.$emit("on-height", height);
    },
    // 联系我们
    contactUs() {},
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
<style lang="scss">
@import "~@/style/media.scss";
@import "~@/style/mixins.scss";
.mfaq-common-header {
  direction: ltr;
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    .btn-wrap {
      display: inline-flex;
    }
  }
  .title {
    width: 80%;
    @include ellipsis;
  }
  @include media-min-md {
    .menu {
      display: block !important;
    }
    .menu-button {
      display: none !important;
    }
    .title {
      width: 100%;
    }
  }
  .mask {
    background: rgba(0, 0, 0, 0.65);
    opacity: 0.3;
    position: fixed;
    width: 100%;
    height: 100%;
  }
  .menu,
  .mask {
    transition: all 0.5s;
  }
}
</style>
